/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies

// UI lib components
import { Paper, Box } from '@mantine/core';

// UI local components

// Styles
import classes from './account-settings.module.css';

// Constants
import { ProfileForm } from '@features/account-settings/components/ProfileForm';

const AccountSettings = () => {
	/* ********************************** HOOKS ********************************* */

	/* ******************************** RENDERING ******************************* */
	return (
		<Paper className={classes.container}>
			<Box className={classes.bloc} />
			<ProfileForm />
			<Box className={classes.bloc} />
		</Paper>
	);
};

export default AccountSettings;
